import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  header: {
    padding: theme.spacing(3),
    border: "1px solid rgba(224, 224, 224, 1)",
    borderBottom: 0,
  },
}));
